/**
 * @desc 通过sku列表获取sku详情数据列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuDetailInfoResponseRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuDetailListBySkuNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
